<template>
  <div>
    <not-allowed
      v-if="!AllowedDisplay"
      :page="page"
      :module="idmodule"
      :data="datas"
    ></not-allowed>

    <div v-if="AllowedDisplay">
      <div v-for="(men, index) in listActions" :key="index">
        <v-btn @click="onClickButton(itemSelected, men)"> <v-icon class="mr-4">{{ men.icon }}</v-icon>{{ men.name }} </v-btn>
        <rights-indicator :checks="actionInspectionChecks(men)" :label="men.name" />
      </div>
      <rights-indicator :checks="chartActionChecks" label="Actions du graphique" />
      <div v-show="datas.series" :ref="'chart' + idmodule" :style="'width: 100%; height: '+height+';'"></div>
    </div>

  </div>
</template>

<script>
import * as echarts from "echarts";
import { client } from '../mixins';

export default {

  mixins : [client],

  data() {
    return {
      AllowedDisplay: true,
      datas: [],
      chartInstance: null,
      listActions : [],
      searchmodule : [],
      itemSelected : {},
      height : false,
    };
  },

  computed: {
    chartActionChecks() {
      const actions = new Map()
      for (const series of this.datas.series || []) {
        for (const point of series.data || []) {
          if (!point || !point.onclick || !point.onclick.set || point.onclick.type !== 'action') continue
          for (const action of point.onclick.actions || []) {
            for (const check of this.actionInspectionChecks(action)) actions.set(String(check.id), check)
          }
        }
      }
      return [...actions.values()]
    },
  },

  watch: {
    "datas.general.type": function (newType) {
      if (this.chartInstance) {
        this.chartInstance.setOption(this.getChartOptions(newType));
      }
    },

    '$route.query'(val, oldVal) {
      const keys = new Set([...Object.keys(val || {}), ...Object.keys(oldVal || {})]);
      if ([...keys].some(key => this.searchmodule.some(id => key.startsWith(id + '_'))
        && JSON.stringify(val[key]) !== JSON.stringify((oldVal || {})[key]))) this.callAPI();
    },

  },

  methods: {


    callAPI() {
      this.API({
        type: "post",
        url: "displaymodule",
        params: { id: this.idmodule, querys: this.$route.query, params: this.$store.getters.specificPage(this.modalKey).params },
      }).then((resp) => {
        this.manageDatas(resp.data);
      });
    },

    manageDatas(data) {
      if (!data.success) {
        this.AllowedDisplay = false;
        this.datas = [];
        return;
      }
      this.height = data.height;
      this.datas = data;
      this.searchmodule = data.search;
      //this.initCharts();
  this.$nextTick(() => {
    this.initCharts();
  });
    },

    initCharts() {
      this.chartInstance = echarts.init(this.$refs["chart" + this.idmodule]);

      this.chartInstance.setOption(this.getChartOptions());
  
      //permet de cibler l'élément qui est cliqué.
      this.chartInstance.on('click', (params) => {
        // on récupère les paramètres du onclick :
        if(params.data.onclick.set) {
          if(params.data.onclick.type=='querys') {

              // épuration des querys du module : Étape 1 : Récupérer les query params actuels, en filtrant ceux qui ne commencent PAS par '125_'
              const filteredQuery = Object.fromEntries(
              Object.entries(this.$route.query).filter(([key]) => !key.startsWith(this.idmodule+"_"))
              );
              let newQuerys = {};
              params.data.onclick.querys.forEach((quer) => {
                if(quer.startsWith('d_')) {
                  newQuerys[quer] = params.data.extendedProps[quer]
                } else {
                  newQuerys[this.idmodule+'_'+quer] = params.data.extendedProps[quer]
                }
                
              })
              var query = {...filteredQuery, ...newQuerys}
              this.$router.push({ query: query }).catch(() => {  });

            //envoi des gets avec id module
          }
          if(params.data.onclick.type=='action') {
            //si il n'y a qu'une seule action on le lance directement, sinon on affiche les boutons :
            if(params.data.onclick.actions.length==1) {
              this.onClickButton(params.data.extendedProps, params.data.onclick.actions[0])
            } else {
              this.itemSelected = params.data.extendedProps
              this.listActions = params.data.onclick.actions
            }

          }
        }
      });   

    },

    getChartOptions() {
      let commonOptions = {
        title: { text: this.datas.general.title.text, left: "center" },
        tooltip: this.datas.general.tooltip,
        legend: this.datas.general.legend,
        grid: this.datas.general.grid,
        dataZoom: this.datas.general.zoom,
        series : this.datas.series,
        toolbox: this.datas.general.toolbox,

      };

      if(this.datas.general.type=='bar' || this.datas.general.type=='line') {
        commonOptions = {
          ...commonOptions,

          ...{
            xAxis : [{
            type:this.datas.general.xaxis.type,
            data:this.datas.categories,
            axisLabel: {
              show:this.datas.general.label.axislabel.show,
                rotate: this.datas.general.label.axislabel.rotate, // ou 60
                interval: this.datas.general.label.axislabel.interval // forcer à afficher tous les labels
            },
            }],
            yAxis : [{
            type:this.datas.general.yaxis.type,
            data:this.datas.categories,
            axisLabel: {
              show:this.datas.general.label.axislabel.show,
                rotate: this.datas.general.label.axislabel.rotate, // ou 60
                interval: this.datas.general.label.axislabel.interval // forcer à afficher tous les labels
            },
            }],
          }
        }
      }

      return commonOptions
    },

    onClickButton: function (item, men) {
      if(men.target=='modal') this.fromThisMod = true;
      this.clickActions({args:item,action:men,idmodule:this.idmodule,page:this.page,modalKey:this.modalKey,
      success:(datas) => {
        if(datas.message) this.$toast.success(datas.message);
          if(men.typelink == 'api') this.callAPI();
      }    
      })

    },

  },

  mounted() {
    let getdatas = this.$store.getters.getModuleDatas({
      page: this.modalKey,
      id: this.idmodule,
    });

    if (getdatas) {
      this.manageDatas(getdatas.datas);
      this.$store.dispatch("removeModuleDatas", {
        page: this.modalKey,
        id: this.idmodule,
      });
    } else {
      this.callAPI();
    }
  },
};
</script>
